/**
 * Profile groups tab.
 */
import React from "react";
import { AvatarGroup, Box } from "@mui/material";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

import { VAvatar, VImage, VText } from "form";
import { BEmpty, BTable } from "components";
import { useAsterController } from "context";
import { getShortDate } from "utils/date";

/**
 * Lists the learner's groups in a table.
 */
const ProfileGroup = () => {
  const { t } = useTranslation("common");

  const [controller] = useAsterController();
  const { groups, loadedDashboard } = controller;

  const columns = [
    {
      name: <VText>{t("Group Name")}</VText>,
      selector: (row) => row.avatar,
      cell: (rw) => (
        <Box className="flex items-center">
          <VImage src={rw.cover_url} className="w-32 h-16 rounded" error="course" />
          <Box className="ml-4">
            <VText color="secondary" className="text-xs bg-gray-100 dark:bg-gray-700 rounded px-1 py-0.5 w-max flex items-center" div>
              <Icon icon="bx:user-circle" />
              &nbsp;{t("Public")}
            </VText>
            <VText>{rw.name}</VText>
          </Box>
        </Box>
      ),
      grow: 2,
    },
    {
      name: <VText>{t("Members")}</VText>,
      selector: (row) => row.first_name,
      cell: (rw) => (
        <Box className="flex justify-start">
          <AvatarGroup max={4} spacing={15} className="v-user-detail-group" total={rw.users?.length}>
            {rw.users.map((v) => (
              <VAvatar key={v.id} size="sm" alt="" src={v.avatar} />
            ))}
          </AvatarGroup>
        </Box>
      ),
    },
    {
      name: <VText>{t("Date Created")}</VText>,
      selector: (row) => row.last_name,
      cell: (rw) => <VText>{getShortDate(rw.created)}</VText>,
    },
  ];

  return (
    <Box className="py-4">
      <BTable columns={columns} data={groups} total={groups.length} loading={!loadedDashboard} />

      {!groups.length && <BEmpty />}
    </Box>
  );
};

export default ProfileGroup;
